import { useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/sui/SuiBox";

// Images
import listEmptyIcon from "assets/images/icons/list-empty.png";

// Soft UI Dashboard PRO React components

import Row from "layouts/developers/applications/components/Row";

// i18m
import { Trans, withTranslation } from "react-i18next";

function ApplicationList({ tableData }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleEditApp = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <Card name="applications" sx={{ width: "100%" }}>
      <TableContainer component={Box}>
        <Table aria-label="collapsible table" component="div">
          <TableHead component="div">
            <TableRow>
              <TableCell align="center">
                <Trans>developers:apps-col1</Trans>
              </TableCell>
              <TableCell>
                <Trans>developers:apps-col2</Trans>
              </TableCell>
              <TableCell align="left">
                <Trans>developers:apps-col3</Trans>
              </TableCell>
              <TableCell align="center">
                <Trans>developers:apps-col4</Trans>
              </TableCell>
              <TableCell align="center">
                <Trans>developers:apps-col5</Trans>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody component="div">
            {tableData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <Row key={row.name} row={row} index={index} handleEditApp={handleEditApp} />
              ))}
          </TableBody>
        </Table>
        {tableData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={tableData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              select: {
                width: "50px",
              },
            }}
          />
        )}
      </TableContainer>
      {tableData.length === 0 && (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          mt={2}
          mb={2}
        >
          <SuiBox component="img" src={listEmptyIcon} alt="Rocketship" mb={3} width="200px" />
          <SuiBox>
            <Trans>developers:apps-empty</Trans>
          </SuiBox>
        </Grid>
      )}
    </Card>
  );
}

ApplicationList.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withTranslation()(ApplicationList);
